// extracted by mini-css-extract-plugin
export default {"heading":"Rs-z","corrected":"Ss-z","redirectVerbiageContainer":"Ts-z","redirectVerbiageText":"Us-z"};